"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridSelectionId = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
const View_1 = require("../../View");
const features_1 = require("../features");
const IndicatorCount = styled_components_1.default.span `
    margin-left: ${helpers_1.SIZE_S};
    ${(props) => props.isSelected &&
    (0, styled_components_1.css) `
            color: ${props.theme.colorTextMain};
            font-weight: ${helpers_1.BASE_FONT_SEMI_BOLD_WEIGHT};
        `}
`;
exports.gridSelectionId = 'grid-selection-box';
function defaultSelectionSubheaderRenderer({ total, selected, texts }) {
    var _a, _b, _c, _d;
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.fill, distribution: StackView_1.STACK_DISTRIBUTION.center, indentHorizontal: View_1.INDENT.s, clipped: true },
        react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.secondary, truncate: true }, (_b = (_a = texts === null || texts === void 0 ? void 0 : texts.selectionSubheader) === null || _a === void 0 ? void 0 : _a.selected) !== null && _b !== void 0 ? _b : 'Selected:',
            react_1.default.createElement(IndicatorCount, { isSelected: !!selected.length }, selected.length),
            ` ${(_d = (_c = texts === null || texts === void 0 ? void 0 : texts.selectionSubheader) === null || _c === void 0 ? void 0 : _c.of) !== null && _d !== void 0 ? _d : 'of'} ${total}`)));
}
const GridSelection = ({ selectionSubheaderRenderer = defaultSelectionSubheaderRenderer, texts }) => {
    const { state: { selection } } = (0, features_1.useGridContext)();
    if (!selection) {
        return null;
    }
    const { multiple, selected, fullLength } = selection;
    if (!multiple) {
        return null;
    }
    const subheader = selectionSubheaderRenderer === null || selectionSubheaderRenderer === void 0 ? void 0 : selectionSubheaderRenderer({
        selected: selected,
        total: fullLength,
        texts
    });
    if (!subheader) {
        return null;
    }
    return (react_1.default.createElement(StackView_1.StackView, { "data-selector-id": exports.gridSelectionId, size: { height: helpers_1.SPACING_XL }, align: StackView_1.STACK_ALIGN.fill, distribution: StackView_1.STACK_DISTRIBUTION.fill, borderBottom: View_1.VIEW_BORDER.grid, clipped: true }, subheader));
};
exports.default = GridSelection;
//# sourceMappingURL=GridSelection.js.map